import { SINGLE } from "../enums/memberCoverageGuaranteeTypes";

/**
 * Determines whether a guarantee should be automatically checked on new
 * coverage or class change, based solely on its client_guarantee_configuration.
 *
 * @param {number} guaranteeId - The guarantee identifier
 * @param {string} guaranteeType - The guarantee type value
 * @param {Array} allGuarantees - All guarantees in the class/coverage (unused, kept for API compat)
 * @param {Array} clientGuaranteeConfigs - Client-level guarantee configurations
 * @returns {boolean}
 */
export default function resolveIsAutomaticallyChecked(
  guaranteeId,
  guaranteeType,
  allGuarantees,
  clientGuaranteeConfigs,
  field,
  member,
  classSwitch = false,
) {
  if (member.isInternational && !field.suitableForInternationalMembers) {
    return false;
  }

  const configs = clientGuaranteeConfigs || [];
  const config = configs.find((c) => c.guaranteeId === guaranteeId);

  if (!field.guarantee) return false;

  if (field.guarantee.isMandatoryDependentGuarantee) {
    const hasAtLeastOneGuaranteeDriving = allGuarantees.find(
      (g) => g.isDrivingMandatoryDependentGuarantee,
    );
    if (!hasAtLeastOneGuaranteeDriving) return false;

    return config && config.isAutomaticallyChecked;
  } else if (field.dependsOnGuaranteeId) {
    let masterGuarantee;

    if (!classSwitch) {
      masterGuarantee = allGuarantees.find(
        (g) =>
          g.clientCoverage.guarantee.guaranteeId ==
            config.dependsOnGuaranteeId &&
          g.clientCoverage.guarantee.isMaster,
      );
    } else {
      masterGuarantee = allGuarantees.find(
        (g) =>
          g.guarantee.guaranteeId ==
            config.dependsOnGuaranteeId &&
          g.guarantee.isMaster,
      );
    }
    if (!masterGuarantee) return false;

    return config && config.isAutomaticallyChecked;
  }

  return config && config.isAutomaticallyChecked;
}



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/coverage/helpers/resolveIsAutomaticallyChecked.js